define('service/finder.service',['require','exports','module','underscore','marionette','backbone.radio','uikit/uikit','blockit','view/finder/base.finder.view','view/finder/person.finder.view','view/finder/unit.finder.view','view/finder/external.org.finder.view','model/provisional.organization.model'],function(require, exports, module) {
  //prettier-ignore
  var _                     = require('underscore'),
      Mn                    = require('marionette'),
      Radio                 = require('backbone.radio'),
      UIKit                 = require('uikit/uikit'),
      BlocKit               = require('blockit'),
      BaseFinderView        = require('view/finder/base.finder.view'),
      PersonFinderView      = require('view/finder/person.finder.view'),
      UnitFinderView        = require('view/finder/unit.finder.view'),
      ExternalOrgFinderView = require('view/finder/external.org.finder.view'),
      ProvisionalOrganizationModel = require('model/provisional.organization.model');

  var FinderService = {
    radioRequests: {
      'finderService register': 'registerContentViewByType',
      'finderService get': 'getContentViewByType',
      'finderService open': 'openByFinderType',
    },

    privateChannel: new Radio.Channel(),

    openByFinderType: function(typeName, options) {
      var ContentView = this.getContentViewByType(typeName);
      var options = options || {};
      var headerText = options.headerText || '';

      var FinderModal = UIKit.Modal2.extend({
        options: _.extend({}, UIKit.Modal2.prototype.options, {
          closable: true,
          closeIcon: false,
          size: '',
        }),

        internalViewOptions: {
          headerView: function() {
            return {
              type: UIKit.Text.extend({
                tagName: 'div',
                className: 'header',
              }),
              text: headerText,
            };
          },
          contentView: function() {
            return _.extend({}, options, {
              type: ContentView,
              selectedCollection: options.selectedCollection,
            });
          },
          actionsView: function() {
            return {
              type: UIKit.ComponentsContainerView.extend({
                className: 'actions',
                childView: UIKit.Button,
                components: [
                  {
                    type: UIKit.Modal2.ModalDenyButtonView,
                    name: 'denyButton',
                    text: 'Cancel',
                    color: 'basic',
                    onPress: function() {
                      finderModal.visible = false;
                    },
                  },
                  {
                    type: UIKit.Button,
                    name: 'addButton',
                    text: 'Request New External Org',
                    color: 'primary',
                    icon: 'plus',
                    onPress: function() {
                      Radio.channel('externalOrgAdderService').request('open', { finderOptions: options });
                    },
                    behaviors: {
                      UpdateActionViewBehavior: {
                        behaviorClass: Mn.Behavior.extend({
                          onFirstBeforeRender: function() {
                            if (finderModal.contentView.getSearchCollection) {
                              this.listenTo(finderModal.contentView.getSearchCollection(), 'update', function() {
                                finderModal.actionsView.render();
                              });
                            }
                          },
                        }),
                      },
                      BindAndFormatOptionValuesBehavior: {
                        optionValues: {
                          disabled: {
                            formatter: function() {
                              return (
                                finderModal.contentView.getSearchCollection &&
                                finderModal.contentView.getSearchCollection().length > 0
                              );
                            },
                          },
                          visible: {
                            formatter: function() {
                              return typeName === 'ExternalOrg';
                            },
                          },
                        },
                        behaviorClass: BlocKit.BindAndFormatOptionValuesBehavior,
                      },
                    },
                  },
                  {
                    type: UIKit.Button.extend({
                      className: UIKit.Button.prototype.className + ' confirm',
                    }),
                    text: 'Save',
                    color: 'primary',
                    name: 'confirmButton',
                    behaviors: {
                      EnableOnlyOnUnsavedChangesBehavior: {
                        collection: options.selectedCollection,
                        behaviorClass: BlocKit.EnableOnlyOnUnsavedChangesBehavior,
                      },
                    },
                  },
                ],
              }),
            };
          },
        },
      });

      var finderModal = new FinderModal();

      finderModal.listenTo(finderModal, 'confirm', function() {
        if (options.updateView && options.selectedCollection) {
          if (this.headerView.getOption('text') === 'External Org Finder') {
            var disclosureId = Radio.request('AppKit.resourceService', 'resource', 'disclosure').get('id');
            // COI-1981: OrgFinder always saves ONLY first selection from array of selected ExtOrgs
            //var orgModel = new ProvisionalOrganizationModel(options.selectedCollection.models[0].attributes);
            var lastAddedModel = _.last(options.selectedCollection.models);
            var orgModel = new ProvisionalOrganizationModel(lastAddedModel.attributes);

            console.log('model to save below:');
            console.log(orgModel);

            orgModel.urlParams({ disclosureId: disclosureId });
            orgModel.saveExternalOrg();
          }
          options.updateView.updateAnswerValueCollectionFromSelectedCollection(options.selectedCollection);
        }
      });

      finderModal.listenTo(finderModal, 'modal:visible', function() {
        if (options.newModel) {
          options.selectedCollection.add(options.newModel);
        }
      });

      _.defer(function() {
        finderModal.visible = true;
      });

      return finderModal;
    },

    registerContentViewByType: function(typeName, Constructor) {
      var replyName = typeName.replace(/\s/g, '_');

      this.privateChannel.reply(replyName, _.constant(Constructor));

      return this;
    },

    getContentViewByType: function(typeName) {
      var requestName = typeName.replace(/\s/g, '_');

      return this.privateChannel.request(requestName) || this.privateChannel.request('Base');
    },
  };

  FinderService.registerContentViewByType('Base', BaseFinderView);
  FinderService.registerContentViewByType('Person', PersonFinderView);
  FinderService.registerContentViewByType('Unit', UnitFinderView);
  FinderService.registerContentViewByType('ExternalOrg', ExternalOrgFinderView);

  module.exports = FinderService;
});

